import { LoadMode } from "./index195.js";
import { mainLoadOptions } from "./index247.js";
import { ThreadController } from "./index248.js";
import { ThreadOptions } from "./index246.js";
const tol = 1e-5;
function getForecastedThread({ context, boundary, holes, steps = 40, stepSize = 1, rng, loadMode, edgeWeightMods = [], maxWingLength }) {
  const thread = ThreadController.createMain({ context, boundary, holes, rng, loadOptions: mainLoadOptions[loadMode], edgeWeightMods, maxWingLength });
  if (!thread)
    return;
  const dir = thread.data.dir;
  const loadOptions = loadMode === LoadMode.single ? ThreadOptions.singleLoadOptions : ThreadOptions.doubleLoadOptions;
  const allBranches = loadOptions.map(({ start, right, load }) => getPossibleBranches({ thread, steps, stepSize, start, right, load }));
  const combo = getBestCombo(thread, allBranches);
  if (combo.start) {
    const diff = combo.start.shrink;
    thread.data.start.addScaledVector(dir, diff);
    thread.data.size -= diff;
  }
  if (combo.end) {
    const diff = combo.end.shrink;
    thread.data.end.addScaledVector(dir, -diff);
    thread.data.size -= diff;
  }
  snapToGrid(thread, combo);
  return thread;
}
function splitOptions(allBranchOptions) {
  const starts = [];
  const ends = [];
  for (const branchOption of allBranchOptions) {
    if (branchOption.start)
      starts.push(branchOption);
    else
      ends.push(branchOption);
  }
  return { starts, ends };
}
function getBestLShape({ thread, options, bestSize, bestCombo }) {
  if (!options.length)
    return { bestSize, bestCombo };
  const allOptions = options.flatMap((b) => b.options);
  const isStart = options[0].start;
  for (const branchOption of allOptions) {
    const size = thread.data.size + branchOption.branch.data.size - branchOption.shrink;
    if (size <= bestSize)
      continue;
    bestSize = size;
    bestCombo = {};
    if (isStart)
      bestCombo.start = branchOption;
    else
      bestCombo.end = branchOption;
  }
  return { bestSize, bestCombo };
}
function getBestUShape({ thread, starts, ends, bestSize, bestCombo }) {
  if (!starts.length)
    return { bestSize, bestCombo };
  if (!ends.length)
    return { bestSize, bestCombo };
  for (const sideStarts of starts) {
    const startRight = sideStarts.right;
    for (const start of sideStarts.options) {
      for (const sideEnds of ends) {
        const endRight = sideEnds.right;
        for (const end of sideEnds.options) {
          if (!passFace2Face({ thread, start, end, startRight, endRight }))
            continue;
          const size = start.branch.data.size + end.branch.data.size + thread.data.size - start.shrink - end.shrink;
          if (size <= bestSize)
            continue;
          bestSize = size;
          bestCombo = { start, end };
        }
      }
    }
  }
  return { bestSize, bestCombo };
}
function snapToGrid(thread, combo) {
  if (!thread.context.gridCellWidth)
    return;
  if (!combo.start || !combo.end)
    return;
  const { loadToCornerCoreDepth, loadToCornerCoreWidth, gridCellWidth } = thread.data.context;
  const innerLoadSize = thread.data.size - loadToCornerCoreDepth - loadToCornerCoreWidth;
  const diff = innerLoadSize % gridCellWidth;
  thread.data.size -= diff;
  if (!combo.start.shrink) {
    thread.data.end.addScaledVector(thread.data.dir, -diff);
  } else {
    thread.data.start.addScaledVector(thread.data.dir, diff);
  }
}
function passFace2Face({ thread, start, end, startRight, endRight }) {
  if (startRight !== endRight)
    return true;
  return thread.context.face2face + tol * 2 <= thread.data.size - start.shrink - end.shrink - start.branch.data.depth - end.branch.data.depth;
}
function getBestCombo(thread, branchOptions) {
  const { starts, ends } = splitOptions(branchOptions);
  let bestSize = thread.data.size;
  let bestCombo = {};
  ({ bestSize, bestCombo } = getBestLShape({ thread, bestSize, bestCombo, options: starts }));
  ({ bestSize, bestCombo } = getBestLShape({ thread, bestSize, bestCombo, options: ends }));
  ({ bestSize, bestCombo } = getBestUShape({ thread, bestSize, bestCombo, starts, ends }));
  return bestCombo;
}
function getPossibleBranches({ thread, steps, stepSize, start, right, load }) {
  const originalStart = thread.data.start.toArray();
  const originalEnd = thread.data.end.toArray();
  const dir = thread.data.dir;
  const allOptions = { start, right, load, options: [] };
  for (let i = 0; i < steps; i++) {
    const branch = thread.add({ start, right, load });
    if (start)
      thread.data.start.addScaledVector(dir, stepSize);
    else
      thread.data.end.addScaledVector(dir, -stepSize);
    if (!branch)
      continue;
    allOptions.options.push({
      branch,
      shrink: i * stepSize
    });
  }
  thread.data.start.fromArray(originalStart);
  thread.data.end.fromArray(originalEnd);
  return allOptions;
}
export {
  getForecastedThread
};
//# sourceMappingURL=index238.js.map
